/* f24-lead.js — envío del formulario de descarga de catálogo.
 *
 * El POST va DIRECTO al Inbound Webhook de GHL. No pasa por Make (su plan Core
 * son 10,000 ops/mes y el 19-jul se agotó y apagó los bots de tres clientes)
 * ni por una Edge Function de Supabase (que se cayó 25 h en este mismo cliente
 * el 15-ago). Este POST es el único punto de captura de toda la pieza: meterle
 * una dependencia más solo cambia dónde se rompe.
 *
 * `mode:'no-cors'` deja la respuesta opaca, así que el navegador NUNCA sabe si
 * GHL recibió. Es una limitación real y conocida, y por eso hay reconciliación
 * semanal de generate_lead (GA4) contra el conteo del tag en GHL.
 */
(function () {
  'use strict';

  // Una página normal trae una sola instancia, pero /pages/catalogos podría
  // acabar con dos (hub + flipbook embebido) y con querySelector la segunda
  // quedaría muerta: se ve bien y no manda nada. Se enganchan todas.
  var roots = document.querySelectorAll('[data-f24-lg]');
  if (!roots.length) return;
  Array.prototype.forEach.call(roots, montar);

  function montar(root) {

  var form = root.querySelector('[data-f24-lg-form]');
  var btn = root.querySelector('[data-f24-lg-btn]');
  var state = root.querySelector('[data-f24-lg-state]');
  var WEBHOOK = root.getAttribute('data-webhook') || '';
  var GRACIAS = root.getAttribute('data-gracias') || '/pages/promociones-descargas';
  var SOURCE = root.getAttribute('data-source') || 'promociones';
  var FOLLETO = root.getAttribute('data-folleto') === '1';
  var TS_RENDER = Date.now();

  function track(name, props) {
    props = props || {};
    try { if (window.gtag) window.gtag('event', name, props); } catch (e) {}
    try { if (window.posthog) window.posthog.capture(name, props); } catch (e) {}
  }

  /* --- UTMs: se guardan en sessionStorage para que sobrevivan la navegación
     interna. Alguien llega por un ad a /pages/promociones, navega a
     /pages/catalogos y llena el form ahí: sin esto la atribución se pierde. --- */
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
  function utms() {
    var out = {}, qs = new URLSearchParams(location.search), i, k, v;
    for (i = 0; i < UTM_KEYS.length; i++) {
      k = UTM_KEYS[i];
      v = qs.get(k);
      if (v) { try { sessionStorage.setItem('f24_' + k, v); } catch (e) {} }
      else { try { v = sessionStorage.getItem('f24_' + k); } catch (e) { v = null; } }
      out[k] = v || '';
    }
    return out;
  }

  /* --- Teléfono a E.164. GHL rechaza los que no traen lada, y uno mal
     normalizado crea un contacto duplicado que el bot nunca encuentra: es el
     fallo más probable de todo el sistema. --- */
  function telE164(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.length === 10) d = '52' + d;
    else if (d.length === 12 && d.slice(0, 2) === '52') { /* ya viene bien */ }
    else if (d.length === 13 && d.slice(0, 3) === '521') d = '52' + d.slice(3); // "1" legacy
    else return null;
    if (/^(\d)\1+$/.test(d.slice(2))) return null; // 5555555555 y familia
    return '+' + d;
  }

  function err(input, msgId, msg) {
    var p = form.querySelector('#' + msgId) || document.getElementById(msgId);
    if (p) p.textContent = msg || '';
    if (input) {
      if (msg) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
    return !msg;
  }

  var started = false;
  form.addEventListener('focusin', function () {
    if (started) return;
    started = true;
    track('lead_form_start', { source: SOURCE });
  });

  /* Vista del form: una sola vez, con medio bloque visible por un segundo. */
  if ('IntersectionObserver' in window) {
    var seen = false;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (!e.isIntersecting || seen) return;
        seen = true;
        setTimeout(function () {
          track('lead_form_view', { source: SOURCE, folleto_ok: FOLLETO ? 1 : 0 });
        }, 1000);
        io.disconnect();
      });
    }, { threshold: 0.5 });
    io.observe(root);
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();

    var elNombre = form.querySelector('[name="nombre"]');
    var elWa = form.querySelector('[name="whatsapp"]');
    var elMail = form.querySelector('[name="email"]');
    var elPerfil = form.querySelector('[name="perfil"]:checked');

    var ok = true, primero = null;

    var nombre = (elNombre.value || '').trim();
    if (nombre.length < 2 || /https?:\/\//i.test(nombre)) {
      ok = err(elNombre, 'f24lg-e-nombre', 'Escribe tu nombre.') && ok;
      primero = primero || elNombre;
      track('lead_form_error', { source: SOURCE, field: 'nombre' });
    } else err(elNombre, 'f24lg-e-nombre', '');

    var tel = telE164(elWa.value);
    if (!tel) {
      ok = err(elWa, 'f24lg-e-wa', 'Escribe tu WhatsApp a 10 dígitos.') && ok;
      primero = primero || elWa;
      track('lead_form_error', { source: SOURCE, field: 'whatsapp' });
    } else err(elWa, 'f24lg-e-wa', '');

    var email = (elMail.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      ok = err(elMail, 'f24lg-e-email', 'Revisa tu correo.') && ok;
      primero = primero || elMail;
      track('lead_form_error', { source: SOURCE, field: 'email' });
    } else err(elMail, 'f24lg-e-email', '');

    if (!elPerfil) {
      err(null, 'f24lg-e-perfil', 'Elige la opción que te representa.');
      ok = false;
      primero = primero || form.querySelector('[name="perfil"]');
      track('lead_form_error', { source: SOURCE, field: 'perfil' });
    } else err(null, 'f24lg-e-perfil', '');

    if (!ok) { if (primero) primero.focus(); return; }

    var wa = form.querySelector('[name="alerta_whatsapp"]').checked ? 'si' : 'no';
    var mailOpt = form.querySelector('[name="alerta_email"]').checked ? 'si' : 'no';
    var hp = (form.querySelector('[name="empresa_web"]').value || '').trim();
    var rapido = (Date.now() - TS_RENDER) < 3000 ? '1' : '0';

    btn.setAttribute('disabled', 'disabled');
    btn.textContent = 'Enviando…';
    if (state) state.textContent = 'Preparando tu descarga…';

    var u = utms();
    var p = new URLSearchParams();
    p.append('nombre', nombre);
    p.append('telefono', tel);
    p.append('email', email);
    p.append('perfil', elPerfil.value);
    p.append('alerta_whatsapp', wa);
    p.append('alerta_email', mailOpt);
    p.append('pagina', location.origin + location.pathname);
    p.append('source', SOURCE);
    p.append('ciclo_promo', root.getAttribute('data-ciclo') || '');
    p.append('consent_version', 'consent-v1');
    p.append('folleto_ok', FOLLETO ? '1' : '0');
    p.append('f24_form_v', '1');
    p.append('empresa_web', hp);          // honeypot: se manda, GHL lo filtra
    p.append('bot_suspect', rapido);      // idem
    p.append('fecha', new Date().toISOString());
    UTM_KEYS.forEach(function (k) { p.append(k, u[k]); });

    track('generate_lead', {
      source: SOURCE, perfil: elPerfil.value,
      optin_wa: wa, optin_email: mailOpt,
      folleto_ok: FOLLETO ? 1 : 0, bot_suspect: rapido
    });
    try { if (window.posthog) window.posthog.register({ f24_perfil: elPerfil.value }); } catch (e) {}

    var ido = false;
    function go() {
      if (ido) return;
      ido = true;
      // El perfil viaja para personalizar el copy de la gracias. Nunca el
      // teléfono ni el correo: no se mete PII en una URL.
      location.href = GRACIAS + '?p=' + encodeURIComponent(elPerfil.value) + '&ok=1';
    }

    if (WEBHOOK && WEBHOOK.indexOf('PENDING') === -1) {
      fetch(WEBHOOK, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: p.toString()
      }).then(go).catch(go);
      setTimeout(go, 2500); // red de seguridad: la promesa opaca puede colgarse
    } else {
      go();
    }
  });

  } // montar
})();
